<template>
  <div id="blog-list-container" :class="{ 'scroll-down' : blogView }">
    <div id="rooms">
      <h1 v-if="username === null">Welcome to Enter</h1>
      <h1 v-else>Welcome {{ username }}</h1>
      <div class="room-list">
        <RoomListButton
          v-for="room in roomList"
          v-bind:key="room.id"
          :room="room"
        />
      </div>
      <div class="blog-button" @click="toggleBlog()">
          <p>
            <span v-if="!blogView">Blog ↓</span>
            <span v-else>Enter ↑</span>
        </p>
      </div>
    </div>
    <div id="blog-container">
      <BlogContainer/>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RoomListButton from "./RoomListButton.vue";
import BlogContainer from "./BlogContainer.vue";

export default {
  name: "RoomList",
  props: ["show", "m"],
  data() {
    return {
      role: "",
      roomList: [],
      loading: false,
      infoFold: true,
      blogView: false
    };
  },
  computed: {
    username() {
      return this.$store.state.username;
    },
  },
  components: {
    RoomListButton, BlogContainer
  },
  mounted() {
    // reset participant limit notification to false
    this.$store.commit("limitNotification", false);

    axios
      .get("https://api.enter.hetnieuweinstituut.nl/rooms?_sort=buttonSize:ASC")
      .then((res) => {
        const relevantData = res.data.map((x) => {
          const toReturn = {
            name: x.name,
            id: x.id,
            roomOptions: x.roomoptions,
            hasPassword: x.hasPassword,
            buttonSize: x.buttonSize,
            visible: x.visibleInList,
            maxParticipants: x.maxParticipants,
            slug: x.slug,
          };
          return toReturn;
        });
        this.roomList = [...relevantData];
        // this.rooms = [...res.data]
        // console.log(this.rooms)
      });
  },
  methods: {
    toggleInfo() {
      this.infoFold = !this.infoFold;
    },
    toggleBlog() {
      this.blogView = !this.blogView;
    }
  }
};
</script>

<style lang="css">
#rooms {
  position: relative;
  height: 100vh;
  width: 100%;
  top: 0;
  background-color: transparent;
  padding: 20px 20% 20px 20%;
}

#blog-list-container {
  position:absolute;
  height:200%;
  width:100%;
  transition: transform 1s;
  transform: none;
  
}

#blog-list-container.scroll-down {
  transform: translateY(-50%);
}

#blog-container {
  position:relative;
  height:100vh;
  width:100%;
  padding:35px;
}

.room-list {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-y: auto;
}

#rooms h1 {
  width: 100%;
  margin-block-start: 0px;
  margin-bottom: 40px;
  text-align: center;
}

.blog-button {
  position:fixed;
  left: 50vw;
  transform: translateX(-50%);
  z-index:500;
  width: fit-content;
  bottom: 20px;
  height: fit-content;
  box-sizing: border-box;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  border: var(--default-border);
  background-color: var(--default-interface-button-bg-color);
  padding:8px 14px 8px 18px;
  border-radius:40px;
}

.blog-button span {
    font-size: var(--room-button-font-size);
}

.blog-button:hover {
  background-color: var(--default-interface-button-hover-bg-color);
  cursor: pointer;
}
</style>
